import React, { useEffect, useState } from "react";
import Menu from '../../comum/Menu/index.jsx';
import Footer from '../../comum/Footer/index.jsx';
import { Modal, Button } from 'react-bootstrap';
import { api } from '../../services/api.js';
import PontoCard from '../Components/Ponto/PontoCard.jsx';
import { useNavigate } from 'react-router-dom';
import Foto from "../Components/Foto";

const fotoCache = new Map();

function LoadingModal({ show, message }) {
    if (!show) return null;
    return (
        <div className="loading-modal-overlay">
            <div className="loading-modal-content">
                <div
                    className="spinner-border text-primary"
                    role="status"
                    style={{ width: '3rem', height: '3rem' }}
                >
                    <span className="visually-hidden">Loading...</span>
                </div>
                <div style={{ marginTop: 15, fontSize: 18 }}>{message}</div>
            </div>
            <style>{`
                .loading-modal-overlay {
                    position: fixed;
                    top: 0; left: 0; right: 0; bottom: 0;
                    background: rgba(0,0,0,0.5);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 1050;
                }
                .loading-modal-content {
                    background: white;
                    padding: 20px 40px;
                    border-radius: 8px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    box-shadow: 0 0 10px rgba(0,0,0,0.25);
                }
            `}</style>
        </div>
    );
}

function AprovacaoPonto() {
    const [registros, setRegistros] = useState([]);
    const [pesquisa, setPesquisa] = useState(0);
    const [loading, setLoading] = useState(false);
    const [erroPermissao, setErroPermissao] = useState(false); // Novo estado para erro de permissão
    const [loja, setLoja] = useState(0);
    const [loadingMessage, setLoadingMessage] = useState('');
    const [temPermissao, setTemPermissao] = useState(null);
    const [lojasPermitidas, setLojasPermitidas] = useState([]);
    const [fotoSelecionada, setFotoSelecionada] = useState(null);
    const navigate = useNavigate();

    const permitePonto = localStorage.getItem("permitePonto");


    useEffect(() => {
        if (permitePonto === 'N') {
            setTemPermissao(false);
            setErroPermissao(true); // Ativa o modal de erro de permissão
            return;
        }

        const lojaStorage = localStorage.getItem("loja");
        const lojas = JSON.parse(localStorage.getItem("lojasPermitidas") || "[]");

        if (lojaStorage) {
            setLoja(lojaStorage);
            setPesquisa(lojaStorage);
        }

        setLojasPermitidas(lojas);
        setTemPermissao(permitePonto === "S");
    }, [permitePonto]);

    useEffect(() => {
        if (temPermissao !== true || !loja) return;

        setLoading(true);
        setLoadingMessage('Aguarde... Consultando registros');

        api.get(`/ponto/${pesquisa || loja}/ocorrencia`)
            .then(response => {
                setRegistros(response.data);
                setLoading(false);
            })
            .catch(err => {
                console.error("Erro ao carregar registros de ponto:", err);
                setRegistros([]); // Garante que a lista fique vazia em caso de erro
                setLoading(false);
            });
    }, [pesquisa, loja, temPermissao]);

    function handleUpdate(chapa, data) {
        console.log('Removendo registro:', chapa, data);
        setRegistros(prev =>
            prev.filter(r => !(r.matricula === chapa && r.data === data))
        );
    }

    return (
        <div>
            <Menu modulo="ARBOR" />
            <LoadingModal show={loading} message={loadingMessage} />

            <div className="pagina-home">
                <div className="container-fluid">
                    {temPermissao ? (
                        <>
                            <div className="mb-3">
                                <label>Selecionar Loja:</label>
                                <select
                                    className="form-select"
                                    value={pesquisa}
                                    onChange={e => setPesquisa(e.target.value)}
                                >
                                    <option value="0">Todas permitidas</option>
                                    {lojasPermitidas.map(loja => (
                                        <option key={loja} value={loja}>{loja}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="row g-1">
                                {registros.length > 0 ? (
                                    registros.map(registro => (
                                        <div
                                            className="col-lg-4 col-md-6 col-sm-12"
                                            key={`${registro.matricula}_${registro.data}`}
                                        >
                                            <PontoCard
                                                registro={registro}
                                                onUpdate={handleUpdate}
                                                onExpandFoto={(urlBase64, nome, info01) => {
                                                    setFotoSelecionada({
                                                        foto: urlBase64,
                                                        nome: nome,
                                                        loja: info01 || ""
                                                    });
                                                }}
                                                fotoCache={fotoCache}
                                            />
                                        </div>
                                    ))
                                ) : (
                                    <div className="no-item">Sem registros</div>
                                )}
                            </div>
                        </>
                    ) : (
                        <div className="no-access"></div>
                    )}

                    <Modal show={erroPermissao} onHide={() => navigate('/arbor/dadosFunc')} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Acesso Negado</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Você não possui permissão para acessar o módulo de <strong>Aprovação de Ponto</strong>.
                            <br />
                            Caso acredite que isso é um erro, entre em contato com o administrador do sistema.
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => navigate('/arbor/dadosFunc')}>
                                Voltar ao início
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    <Foto
                        show={!!fotoSelecionada}
                        onClose={() => setFotoSelecionada(null)}
                        foto={fotoSelecionada?.foto}
                        nome={fotoSelecionada?.nome}
                        info01={fotoSelecionada?.loja}
                        info02=""
                    />
                </div>

                {!loading && <Footer className="footer navbar-fixed-bottom" />}
            </div>
        </div>
    );
}

export default AprovacaoPonto;